import { render, staticRenderFns } from "./GoWizardLogo.vue?vue&type=template&id=cd3d52ea&scoped=true"
import script from "./GoWizardLogo.vue?vue&type=script&lang=js"
export * from "./GoWizardLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3d52ea",
  null
  
)

export default component.exports